module.exports = "<p>\n  recipe-item works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recipes/recipe-list/recipe-item/recipe-item.component.html
// module id = 157
// module chunks = 1